import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router';

import AuthLayout from '../layout/Auth/AuthLayout';
import DashboardLayout from '../layout/Dashboard/DashboardLayout';
import EnrollPasskey from '../pages/Auth/Passkeys/EnrollPasskey';
import SignIn from '../pages/Auth/SignIn/SignIn';
import Analytics from '../pages/Dashboard/Analytics/Analytics';
import Feedback from '../pages/Dashboard/Feedback/Feedback';
import Limits from '../pages/Dashboard/Limits/Limits';
import Passkeys from '../pages/Dashboard/Passkeys/Passkeys';
import Profit from '../pages/Dashboard/Profit/Profit';
import Sessions from '../pages/Dashboard/Sessions/Sessions';
import Customer from '../pages/Dashboard/Customers/Customer';
import Dashboard from '../pages/Dashboard/Dashboard/Dashboard';
import Inbox from '../pages/Dashboard/Inbox/Inbox';
import Gifts from '../pages/Dashboard/Gifts/Gifts';
import Reconciliation from '../pages/Dashboard/Reconciliation/Reconciliation';
import RiskCenter from '../pages/Dashboard/RiskCenter/RiskCenter';
import Schedules from '../pages/Dashboard/Schedules/Schedules';
import Transactions from '../pages/Dashboard/Transactions/Transactions';
import { NotFound404 } from '../pages/NotFound404';
import {
  ACCOUNT,
  ANALYTICS,
  CUSTOMERS,
  DASHBOARD,
  INBOX,
  FEEDBACK,
  LIMITS,
  PASSKEY_ENROLL,
  PASSKEYS,
  PROFIT,
  SESSIONS,
  GIFTS,
  NOTFOUND,
  RECONCILIATION,
  RISK_CENTER,
  SCHEDULES,
  SIGNIN,
  TRANSACTIONS,
} from './routeConstants';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { path: '/', element: <Navigate to={DASHBOARD} /> },
      { path: DASHBOARD, element: <Dashboard /> },
      { path: INBOX, element: <Inbox /> },
      { path: `${CUSTOMERS}/:chatId`, element: <Customer /> },
      { path: TRANSACTIONS, element: <Transactions /> },
      { path: SCHEDULES, element: <Schedules /> },
      { path: GIFTS, element: <Gifts /> },
      { path: RISK_CENTER, element: <RiskCenter /> },
      { path: RECONCILIATION, element: <Reconciliation /> },
      { path: ANALYTICS, element: <Analytics /> },
      { path: SESSIONS, element: <Sessions /> },
      { path: PROFIT, element: <Profit /> },
      { path: LIMITS, element: <Limits /> },
      { path: FEEDBACK, element: <Feedback /> },
      { path: PASSKEYS, element: <Passkeys /> },
      { path: NOTFOUND, element: <NotFound404 /> },
      { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
    ],
  },

  {
    path: ACCOUNT,
    element: <AuthLayout />,
    children: [
      { path: SIGNIN, element: <SignIn /> },
      { path: PASSKEY_ENROLL, element: <EnrollPasskey /> },
      { path: NOTFOUND, element: <NotFound404 /> },
      { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
    ],
  },

  { path: '*', element: <NotFound404 /> },
]);
